"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importStar(require("react"));
var color_1 = require("../utils/color");
function mapColor(color, disabledColor, disabled) {
    color = color || "blue";
    disabledColor = disabledColor || "bg-grey-light";
    if (disabled) {
        return disabledColor;
    }
    var darkColor = (0, color_1.darken)(color);
    var darkerColor = (0, color_1.darken)(darkColor);
    // treat white buttons specially because the shadow looks like too much
    var activeShadow = color === "white" ? "active:bg-".concat(color) : "active:shadow-inner-button";
    return "bg-".concat(color, " border-").concat(darkColor, " hover:bg-").concat(darkColor, " hover:border-").concat(darkerColor, "\n").concat(activeShadow);
}
exports.Button = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, color = _a.color, className = _a.className, disabled = _a.disabled, disabledColor = _a.disabledColor;
    return (react_1.default.createElement("button", { disabled: disabled, className: className ||
            "border px-3 py-1 rounded text-white ".concat(mapColor(color, disabledColor, disabled)), onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, ref: ref }, color === "white" || disabled ? (react_1.default.createElement("span", { className: "text-grey-darker" }, children)) : (children)));
});
